module.exports = __webpack_public_path__ + "img/title_text.d38e93c4.png";